import React from 'react'
import Header from '../../components/Header'
import HeaderImage from '../../img/about1.jpg'
import StoryImage from '../../img/donne2.jpg'
import VisionImage from '../../img/ekip_header3.jpg'
import MissionImage from '../../img/ekip.jpg'
import './about.css'
const About = () => {
    return (
        <>
            <Header title="Bienvenue dans notre histoire " image={HeaderImage}> 
                 Découvrez notre parcours inspirant dans le domaine de la formation et de la création digitale. Plongez dans notre univers où passion, innovation et expertise se rencontrent pour vous offrir des solutions sur mesure. Bienvenue dans notre histoire, où chaque étape est marquée par des succès, des défis et une volonté inébranlable de repousser les limites de l'excellence.
         </Header>
            
            <section className="about__story">
                <div className="container about__story-container">
                    <div className="about__section-image">
                        <img src={StoryImage} alt="_EKIP Historique" />
                    </div>
                    <div className="about__section-content">
                        <h1> Historique </h1>
                        <p>
                            Fondée en 2021, notre organisation a débuté avec une vision claire : offrir une éducation de qualité dans le domaine de la technologie. Depuis lors, nous avons formé une dizaine d'étudiants qui sont devenus des professionnels talentueux et compétents.
                        </p>
                        <p>
                            Au fil des années, nous avons constamment amélioré nos programmes et nos méthodes d'enseignement pour rester à la pointe de l'innovation technologique. Nous avons établi des partenariats avec des entreprises de renom et des experts du secteur pour offrir à nos étudiants les meilleures opportunités de carrière.
                        </p>
                        <p>
                            Notre engagement envers l'excellence académique et le succès de nos étudiants reste notre priorité absolue. Nous sommes fiers de notre héritage en tant qu'institution éducative de premier plan et nous nous efforçons continuellement de repousser les limites de l'apprentissage technologique.
                        </p>

                        
                    </div>
                </div>
            </section>


             <section className="about__vision">
                <div className="container about__vision-container">
                   
                    <div className="about__section-content">
                        <h1> Notre Vision </h1>
                        <p>
                            Notre vision est de créer un monde où chaque individu a les compétences technologiques nécessaires pour prospérer dans l'économie numérique en constante évolution. Nous croyons que la technologie est un moteur essentiel du progrès et de l'innovation, et nous nous efforçons de former une génération de leaders technologiques.
                        </p>
                        <p>
                            Nous aspirons à être reconnus comme une référence mondiale dans l'éducation technologique, en fournissant des programmes de formation de haute qualité qui préparent nos étudiants aux défis de demain. Nous visons à cultiver une culture de l'apprentissage continu et à encourager la créativité et l'esprit d'entreprise.
                        </p>
                        <p>
                            En nous appuyant sur notre expertise pédagogique et notre réseau de partenaires, nous cherchons à inspirer et à équiper les individus avec les compétences technologiques nécessaires pour façonner l'avenir. Nous nous engageons à favoriser l'inclusion et la diversité, et à ouvrir des opportunités pour tous, indépendamment de leur origine ou de leur parcours.
                        </p>

                        
                    </div>
                    <div className="about__section-image">
                        <img src={VisionImage} alt="_EKIP Historique" />
                    </div>
                </div>
            </section>

            <section className="about__mission">
                <div className="container about__mission-container">
                    <div className="about__section-image  mission__section-image ">
                        <img src={MissionImage} alt="_EKIP Historique" />
                    </div>
                    <div className="about__section-content">
                        <h1> Notre Mission </h1>
                        <p>
                            Notre mission est de démocratiser l'accès à l'éducation technologique de qualité, en offrant des programmes de formation abordables et accessibles à tous. Nous voulons éliminer les barrières à l'apprentissage et permettre à chacun de développer ses compétences technologiques, quels que soient son âge, son niveau d'expérience ou ses ressources.
                        </p>
                        <p>
                            Nous nous engageons à fournir des cursus pertinents et axés sur les compétences demandées sur le marché du travail. Nous travaillons en étroite collaboration avec des professionnels de l'industrie pour garantir que nos programmes sont alignés sur les besoins actuels et futurs du secteur technologique.
                        </p>
                        <p>
                            En plus de l'acquisition de compétences techniques, nous attachons une grande importance au développement des compétences.
                            </p>

                    </div>
                </div>
            </section>
        </>
    )
}

export default About
